import * as React from 'react';
import styled from 'styled-components';
import { FaLine } from "react-icons/fa";
import { useTranslation } from 'react-i18next';

import { useRecoilState ,useRecoilValue} from 'recoil';//取得のみ
import { langState } from "../../states/langState";
import { configJsonState } from "../../states/configJsonState";

import { HelpPageLink } from '../../components/06mypage/helpPageLinkComponent';
import { MarketplaceBrowserwalletButton } from '../../components/06mypage/marketplaceBrowserwalletButtonComponent';
import { MyPageTitle } from '../../components/06mypage/mypageTitleComponent';
import { SelectMarketplaceButton } from '../../components/06mypage/selectMarketplaceButtonComponent';
import { UseNFTBackupcardButton } from '../../components/06mypage/useNftBackupcardButtonComponent';
import { SushiFooter } from '../../components/suishiFooterComponent';
import { GotoMyAppButton } from '../../components/06mypage/gotoMyAppButtonComponent';
import { GetNFTagainButton } from '../../components/06mypage/getNFTagainButtonComponent';
import { GotoNFTMoverButton } from '../../components/06mypage/gotoNFTMoverButtonComponent';

import { Box, Button, Center, Icon, Image, Text} from '@chakra-ui/react';
import { GotoWebSiteButton } from '../../components/06mypage/gotoWebSiteButton';
import { languageState } from '../../states/languageState';


type Props = {}

export const MyPage: React.FC<Props> = (props) => {
  const [myWalletAddressStatus,setMyWalletAddress] = React.useState(``);
  const [browserWalletAddressStatus,setBrowserWalletAddressStatus] = React.useState(``);
  const [langStatus , setLangStatus] = useRecoilState(langState);
  const [t, i18n] = useTranslation();
  const configStatus = useRecoilValue(configJsonState);
  const [languageStatus , setLanguageStatus] = useRecoilState(languageState);


  const SelectmarketplaceText = styled.p`
     font-weight: 700;
     margin-top: 50px;
  `;
  const MyPageComponent = styled.main`
    min-height: calc(100vh - 60px);
    flex:1;
    text-align: center;
    color: white;
    background-repeat: no-repeat;
    background-size: 100% auto;
    font-family: 'Noto Sans JP',sans-serif;
    height: 100vh;
    justify-content: center;
    display: flow-root;

    background-image: url(${configStatus.backgroundImage});
  `;
  const SwitchButtondiv = styled.div`
    display: inline-flex;
    position: fixed;
    top: 5px;
    font-weight: 600;
    right: 30px;
  `;
  const ENButtonP = styled.div`
    color:${languageStatus.enButtonColor};
    font-weight: 600;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  `;

  const JPButtonP = styled.div`
    color:${languageStatus.jaButtonColor};
    font-weight: 600;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  `;

  const MyPageDiv = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  `;
  
  React.useEffect(()=>{
    (async() => {
      if (localStorage.getItem('addressofmineMM')) {
        setMyWalletAddress(`${localStorage.getItem('addressofmineMM')}`);
      }
      if (localStorage.getItem('walletAddressFromPK')) {
        setBrowserWalletAddressStatus(`${localStorage.getItem('walletAddressFromPK')}`);
      }
    })()
  },[]);
  return (
    <MyPageDiv>
      <MyPageComponent>
          <SwitchButtondiv>
            <ENButtonP
              id='btn-default-en' 
              onClick={()=>{
                i18n.changeLanguage(`en`);
                setLanguageStatus({
                  lang:`en`,
                  jaButtonColor:`darkslategrey`,
                  enButtonColor:`white`,
                  isFirstSetting:true,
                })
              }}
            >EN
            </ENButtonP>
            <p>・</p>
            <JPButtonP 
              id='btn-default-jp'
              onClick={()=>{
                i18n.changeLanguage(`ja`);
                setLanguageStatus({
                  lang:`ja`,
                  jaButtonColor:`white`,
                  enButtonColor:`darkslategrey`,
                  isFirstSetting:true,
                })
              }}
            >JP
            </JPButtonP>
          </SwitchButtondiv>

          <MyPageTitle />
          {configStatus.isGetNFTagainButton === `yes` && <GetNFTagainButton/>}
          {configStatus.web3layerUrl && <GotoWebSiteButton/>}

          {!configStatus.isMyAppLink &&
            <>
              <SelectmarketplaceText>▼{t('マーケットプレイスでNFTを見る')}▼</SelectmarketplaceText>
              {localStorage.getItem('addressofmineMM') && <SelectMarketplaceButton  myWalletAddress={myWalletAddressStatus}/>}
              {localStorage.getItem('privateKey') && <MarketplaceBrowserwalletButton browserWalletAddress={browserWalletAddressStatus}/>}
            </>
          }


          {(configStatus.walletTypeArray.includes(`unWallet`) && configStatus.walletTypeArray.length == 1) && 
            <>
              <Text
                fontWeight={'bold'}
                mt={'50px'}
                mb={'30px'}
              >
                ▼{t('受け取ったNFTの確認方法')}▼
              </Text>

              <Box mb={`30px`}>
                <Text mb={`4px`}>①{t('下のボタンから公式Lineの追加')}</Text>
                <Button
                  w={'314px'}
                  colorScheme="green"
                  leftIcon={<Icon as={FaLine} boxSize={6} />}
                  borderRadius="full"
                  _hover={{ boxShadow: "md" }}
                  onClick={() =>  window.open("https://id.unwallet.world/connect/line")}//mainet
                >
                  <Box as="span" pl={1}>
                    <Text as="span" fontSize="lg">
                      unWallet
                    </Text>
                  </Box>
                </Button>
              </Box>
              <Text>②{t('Line画面からウォレット連携')}</Text>
              <Center>
                <Image
                  src="https://sushitopio-frontend-v4.onrender.com/0beta/unwalletsample/sample.png"
                  alt="line"
                  boxSize={`314px`}
                  border={`5px solid gray`}
                />
              </Center>
            </>
          }

          {(configStatus.isMyAppLink && !configStatus.walletTypeArray.includes(`unWallet`)) &&
            <> 
              <Box mt={`50px`}/>
              <GotoMyAppButton/>  
            </>
          }

          {!configStatus.walletTypeArray.includes(`unWallet`) &&
            <Box mt={'70px'}>
              <GotoNFTMoverButton/>
              <UseNFTBackupcardButton />
            </Box>
          }

          <HelpPageLink />
      </MyPageComponent>
      <SushiFooter footerPragraph1='powered by' footerPragraph2='- Creating a Token-Graph Marketing Culture -'/>
    </MyPageDiv>
  );
};
